import { render, staticRenderFns } from "./creditosestados.vue?vue&type=template&id=27f389ec"
import script from "./creditosestados.vue?vue&type=script&lang=js"
export * from "./creditosestados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports